import { render, staticRenderFns } from "./message-question.vue?vue&type=template&id=39da7b1c&"
import script from "./message-question.vue?vue&type=script&lang=js&"
export * from "./message-question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39da7b1c')) {
      api.createRecord('39da7b1c', component.options)
    } else {
      api.reload('39da7b1c', component.options)
    }
    module.hot.accept("./message-question.vue?vue&type=template&id=39da7b1c&", function () {
      api.rerender('39da7b1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/message-question.vue"
export default component.exports